import { render, staticRenderFns } from "./AddNewValue.vue?vue&type=template&id=2bee0726"
import script from "./AddNewValue.vue?vue&type=script&lang=js"
export * from "./AddNewValue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/msuarez/PycharmProjects/terrada-front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports